import { useState } from "react";
import SmartChart from "../SmartChart/SmartChart";
import "./MetricWidget.css";

export default function MetricWidget({ 
  title, 
  icon, 
  color = "#8b5cf6", 
  paramId, 
  history, 
  stats,
  options = [],
  loading: loadingProp,
  children
}) {
  const [selectedOption, setSelectedOption] = useState(options[0]?.value || paramId);
  const loading = loadingProp ?? (paramId && history == null);
  return (
    <div className="metric-widget">
      <div className="widget-content">
        <div className="widget-header">
          <div className="widget-title">
            {icon && <span className="widget-icon">{icon}</span>}
            <h3>{title}</h3>
          </div>
          
          {stats && (
            <div className="widget-stats">
              <span>Média: {stats.avg}</span>
              <span>Máx: {stats.max}</span>
              <span>Mín: {stats.min}</span>
            </div>
          )}
        </div>

        {children}

        {options.length > 0 && (
          <div className="widget-options">
            <select 
              value={selectedOption}
              onChange={(e) => setSelectedOption(e.target.value)}
              className="widget-select"
            >
              {options.map(opt => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className="widget-chart">
          <SmartChart 
            history={history} 
            paramId={selectedOption || paramId}
            height={280}
            loading={loading}
          />
        </div>
      </div>
    </div>
  );
}

